import React, { ReactElement } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const SendIcon = (props: SvgIconProps): ReactElement => {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <g clipPath="url(#clip0_10241_5354)">
                <path
                    d="M18.3334 1.66667L9.16675 10.8333"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill="none"
                />
                <path
                    d="M18.3334 1.66667L12.5001 18.3333L9.16675 10.8333L1.66675 7.50001L18.3334 1.66667Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill="none"
                />
            </g>
            <defs>
                <clipPath id="clip0_10241_5354">
                    <rect width="20" height="20" fill="none" />
                </clipPath>
            </defs>
        </SvgIcon>
    );
};
